import { render, staticRenderFns } from "./user-advertising-old.vue?vue&type=template&id=9ea8b72c&scoped=true"
import script from "./user-advertising-old.vue?vue&type=script&lang=js"
export * from "./user-advertising-old.vue?vue&type=script&lang=js"
import style0 from "./user-advertising-old.vue?vue&type=style&index=0&id=9ea8b72c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea8b72c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ea8b72c')) {
      api.createRecord('9ea8b72c', component.options)
    } else {
      api.reload('9ea8b72c', component.options)
    }
    module.hot.accept("./user-advertising-old.vue?vue&type=template&id=9ea8b72c&scoped=true", function () {
      api.rerender('9ea8b72c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/user-advertising-old.vue"
export default component.exports